import { CreatePageLayout } from 'framework/ui/layout';
import { FormFieldsData, AfterSubmitProps, FormShowTemplate } from 'framework/form';
import { useNewProjectService } from 'domain/shared/newProject';
import { ProjectUrlParams } from '../../hooks/useProjectUrlParams';
import FormSubmitButtons from '../common/FormSubmitButtons';
import ProjectInitiationFormContent from './ProjectInitiationFormContent';

const ProjectInitiationForm = ({
  urlParams,
  afterSubmit,
}: {
  urlParams: ProjectUrlParams;
  afterSubmit?: AfterSubmitProps<(response: any) => any, string | ((response: any) => any)>;
}) => {
  const { getProjectInitialValidationSchema, initiateProject } = useNewProjectService();

  const getData = async () => ({
    inputData: {
      accountId: urlParams?.accountId,
      opportunityId: urlParams?.opportunityId,
      rawProjectId: urlParams?.rawProjectId,
    },
    requestId: urlParams?.requestId,
    urlParams: urlParams,
  });

  const handleSubmit = async (formData: FormFieldsData) => {
    const shouldRedirect = formData?.project?.createDaVinciRedmine === true;
    const relatedProjectIdData = formData?.project?.existingProject?.id;

    const projectId = await initiateProject(formData);

    return {
      projectId,
      relatedProjectId: relatedProjectIdData,
      shouldRedirectToTools: shouldRedirect,
    };
  };

  return (
    <>
      <FormShowTemplate
        submitFormFunc={handleSubmit}
        afterSubmit={afterSubmit}
        getValidationSchemaFunc={getProjectInitialValidationSchema}
        getDataFunc={getData}
      >
        <CreatePageLayout
          buttons={
            <FormSubmitButtons
              isVisible={data => data?.isProjectAvailable === true}
              submitButtonText={data => (data?.project?.createDaVinciRedmine === true ? 'Next step' : 'Submit')}
            />
          }
        >
          <ProjectInitiationFormContent />
        </CreatePageLayout>
      </FormShowTemplate>
    </>
  );
};

export default ProjectInitiationForm;
